import { useEffect, useState } from "react";
import client from "../api/client";

const val = (r, a, b) => r?.[a] ?? r?.[b] ?? 0;
const money = (n) => Number(n || 0).toFixed(2);

export default function StockSummaryPage() {
  const [rows, setRows] = useState([]);
  const companyId = Number(localStorage.getItem("companyId") || 0);
  const load = async () => {
    const res = await client.get(
      `/inventory/stock-summary${companyId ? `?companyId=${companyId}` : ""}`,
    );
    setRows(Array.isArray(res.data) ? res.data : []);
  };
  useEffect(() => {
    load();
  }, []);
  const totalValue = rows.reduce(
    (s, r) => s + Number(val(r, "ClosingValue", "closingValue") || 0),
    0,
  );

  return (
    <div className="container-fluid py-2" style={{ fontSize: 11, padding: 0 }}>
      <div
        className="card border-0 shadow-sm"
        style={{ borderRadius: 14, overflow: "hidden" }}
      >
        <div
          className="text-white"
          style={{
            background: "linear-gradient(90deg,#0b4f4a,#0f766e)",
            padding: "8px 12px",
          }}
        >
          <h6 className="m-0" style={{ fontSize: 13, fontWeight: 700 }}>
            <i className="bi bi-boxes me-2"></i>Stock Summary
          </h6>
          <div style={{ fontSize: 10, opacity: 0.85 }}>
            Item-wise opening, inward, outward, closing quantity and value
          </div>
        </div>
        <div className="card-body p-2">
          <div className="d-flex justify-content-between mb-2">
            <span>
              Total Items: <strong>{rows.length}</strong>
            </span>
            <span>
              Closing Value: <strong>{money(totalValue)}</strong>
            </span>
          </div>
          <div
            className="table-responsive"
            style={{
              maxHeight: 500,
              border: "1px solid #e9ecef",
              borderRadius: 10,
            }}
          >
            <table
              className="table table-bordered table-hover mb-0"
              style={{ fontSize: 11, minWidth: 1050 }}
            >
              <thead className="table-dark">
                <tr>
                  {[
                    "Code",
                    "Item",
                    "Unit",
                    "HSN",
                    "GST %",
                    "Opening",
                    "In",
                    "Out",
                    "Closing",
                    "Cost",
                    "Closing Value",
                  ].map((h) => (
                    <th
                      key={h}
                      className={
                        [
                          "Opening",
                          "In",
                          "Out",
                          "Closing",
                          "Cost",
                          "Closing Value",
                          "GST %",
                        ].includes(h)
                          ? "text-end"
                          : ""
                      }
                      style={{ fontSize: 10, whiteSpace: "nowrap" }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 ? (
                  <tr>
                    <td colSpan="11" className="text-center text-muted py-3">
                      No stock found
                    </td>
                  </tr>
                ) : (
                  rows.map((r, i) => (
                    <tr key={val(r, "ItemId", "itemId") || i}>
                      <td className="fw-bold">
                        {val(r, "ItemCode", "itemCode")}
                      </td>
                      <td>{val(r, "ItemName", "itemName")}</td>
                      <td>{val(r, "Unit", "unit")}</td>
                      <td>{val(r, "HSNCode", "hsnCode")}</td>
                      <td className="text-end">
                        {money(val(r, "GSTPercent", "gstPercent"))}
                      </td>
                      <td className="text-end">
                        {money(val(r, "OpeningQty", "openingQty"))}
                      </td>
                      <td className="text-end">
                        {money(val(r, "QtyIn", "qtyIn"))}
                      </td>
                      <td className="text-end">
                        {money(val(r, "QtyOut", "qtyOut"))}
                      </td>
                      <td className="text-end fw-bold">
                        {money(val(r, "ClosingQty", "closingQty"))}
                      </td>
                      <td className="text-end">
                        {money(val(r, "CostPrice", "costPrice"))}
                      </td>
                      <td className="text-end fw-bold">
                        {money(val(r, "ClosingValue", "closingValue"))}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
